export const getQueryOptions = ({
  databaseFieldId,
  workAnniversaryRange,
  startOrEndOfCurrentYear,
  maxTotalNumberOfItems = undefined,
  collectionFilters = [],
}) => ({
  limit: maxTotalNumberOfItems,
  filters: [
    ...collectionFilters,
    {
      column: databaseFieldId,
      value: {
        range: [workAnniversaryRange.start, workAnniversaryRange.end],
      },
      type: "DATE",
      condition: "IS",
      isInDashboard: true,
      recurring: true,
    },
    {
      column: databaseFieldId,
      value: { range: [undefined, startOrEndOfCurrentYear] },
      type: "DATE",
      condition: "IS",
      isInDashboard: true,
      recurring: false,
    },
    {
      isMultiUser: true,
      type: "BOOLEAN",
      value: true,
      column: "hidden",
      condition: "NOT",
    },
  ],
  sort: {
    fieldId: databaseFieldId,
    order: "asc",
    fieldPrefix: "date_field_recurring",
  },
});
